import { render, staticRenderFns } from "./GeneratePaymentBatchComponent.vue?vue&type=template&id=bb0e282c&"
import script from "./GeneratePaymentBatchComponent.vue?vue&type=script&lang=js&"
export * from "./GeneratePaymentBatchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports